type ClassName = string | string[] | undefined;
const parseClassName = (className: ClassName): string => {
  if (Array.isArray(className)) {
    return className
      .map((name) => parseClassName(name))
      .filter((className) => !!className)
      .join(' ');
  }

  if (!className || typeof className !== 'string') {
    return '';
  }

  return className.trim();
};

/**
 * Concatenates class names
 * @param classNames
 * @returns string
 */
export const classNames = (...classNames: ClassName[]) =>
  classNames
    .reduce<string[]>((out, className) => {
      const result = parseClassName(className);
      if (result) {
        out.push(result);
      }
      return out;
    }, [])
    .join(' ');
